import { jwtDecode } from 'jwt-decode'

import { IAccessToken } from 'core/models/access-token'

const issList = ['idpdecathlon.preprod.org', 'idpdecathlon']

export const validateUserAccess = (token?: string): boolean => {
  if (!token) {
    return false
  }
  const decodedAccessToken = jwtDecode<IAccessToken>(token)
  return !(decodedAccessToken == null || !decodedAccessToken.sub || !issList.includes(decodedAccessToken.iss))
}
